// src/authStore.js
import createStore from 'react-auth-kit/createStore';

export const authStore = createStore({
  authName: '_auth',                 // cookie name
  authType: 'cookie',                // use cookies
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === 'https:',
  // if you plan to use refresh tokens, add:
  // refreshTokenKey: 'yourRefreshTokenKey',
});
